// @flow
import Loading from "components/Loading";
import { ResourceSharedContext } from "components/ResourceFill/providers/ResourceSharedProvider";
import useSignatureMemo from "hooks/useSignatureMemo";
import * as React from "react";
import { ZentakeContext } from "utils/ZentakeContext";

import { ResourceResponseContext } from "./providers/ResourceResponseProvider";
import ResourceFillBodyDocument from "./ResourceFillBodyDocument";
import ResourceFillBodyForm from "./ResourceFillBodyForm";

function ResourceFillBody(): React.Node {
  const { isFetching, response } =
    React.useContext(ResourceResponseContext) || {};

  const { mode } = React.useContext(ResourceSharedContext) || {};

  const {
    fetchingClients,
    fetchingUserDetails,
    isFetchingForms,
    fetchingPackets,
  } = React.useContext(ZentakeContext);

  const isLoading =
    isFetching ||
    fetchingClients ||
    fetchingUserDetails ||
    isFetchingForms ||
    fetchingPackets;

  const signatureMemo = useSignatureMemo(mode || "");

  if (isLoading) {
    return <Loading />;
  }

  if (response?.document) {
    return <ResourceFillBodyDocument signatureMemo={signatureMemo} />;
  }

  return <ResourceFillBodyForm signatureMemo={signatureMemo} />;
}

export default ResourceFillBody;
